import {
    useGetDemandInventoryLineGraphDataMutation,
    useGetForecastRebalancingDataMutation,
    useGetInactiveInventoryDataMutation,
    useGetInactiveInventoryPlantLevelDataMutation,
    useGetInactiveInventoryWaterfallDataMutation,
    useGetInventoryFiltersMutation,
    useGetPotentialOverstockDataMutation,
    useGetPotentialOverstockLineGraphDataMutation,
    useGetStockoutDataMutation,
    useGetInventoryHajocaDemoChangesMutation,
    useGetPerformaceMatricsTableMutation,
    useGetPerformaceMatricsChartDataMutation,
    useGetPerformaceMatricsFiltersMutation
} from "../api/inventoryApi";

export const useInventoryFilters=()=>{
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetInventoryFiltersMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}

export const usePotentialOverstockData=()=>{
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetPotentialOverstockDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}

export const useStockOutData=()=>{
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetStockoutDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}

export const useDemandInventoryLineGraphData=()=>{
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetDemandInventoryLineGraphDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}

export const usePotentialOverstockLineGraphData=()=>{
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetPotentialOverstockLineGraphDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}

export const useInactiveInventoryData=()=>{
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetInactiveInventoryDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}

export const useInactiveInventoryWaterfallData=()=>{
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetInactiveInventoryWaterfallDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}


export const useForecastRebalancingData=()=>{
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetForecastRebalancingDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}

export const useGetInactiveInventoryPlantLevelData=()=>{
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetInactiveInventoryPlantLevelDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}

export const useGetInventoryHajocaDemoChanges=()=>{
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetInventoryHajocaDemoChangesMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}

export const useGetPerformaceMatricsTable=()=>{
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetPerformaceMatricsTableMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}

export const useGetPerformaceMatricsChartData=()=>{
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetPerformaceMatricsChartDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}

export const useGetPerformaceMatricsFilters=()=>{
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetPerformaceMatricsFiltersMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}